var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m24,13.5v7c0,.829-.672,1.5-1.5,1.5s-1.5-.671-1.5-1.5v-7c0-1.378-1.121-2.5-2.5-2.5H3.901l4.634,4.414c.6.571.622,1.521.051,2.121-.295.31-.69.465-1.086.465-.372,0-.744-.137-1.035-.414L1.345,12.707c-.876-.875-1.345-2.004-1.345-3.207s.469-2.333,1.318-3.182L6.465,1.414c.601-.571,1.549-.549,2.121.051.571.6.549,1.549-.051,2.121l-4.633,4.414h14.598c3.032,0,5.5,2.467,5.5,5.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndo);
export default __webpack_public_path__ + "static/media/undo.11b1b22c27e9c9d9fb246e081c33a61e.svg";
export { ForwardRef as ReactComponent };